import React from 'react';
import LegalLayout from './LegalLayout';

const PrivacyPolicy: React.FC = () => {
  return (
    <LegalLayout title="プライバシーポリシー">
      <section className="space-y-8">
        <p>株式会社ジーンクエスト（以下「当社」といいます。）は、個人情報保護の重要性について認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）を遵守すると共に、以下のプライバシーポリシー（以下「本プライバシーポリシー」といいます。）に従い、適切な取扱い及び保護に努めます。なお、本プライバシーポリシーにおいて別段の定めがない限り、本プライバシーポリシーにおける用語の定義は、個人情報保護法の定めに従います。</p>

        <div>
          <h2 className="text-lg font-semibold">1. 個人情報の定義</h2>
          <p>本プライバシーポリシーにおいて、個人情報とは、個人情報保護法第2条第1項により定義される個人情報を意味するものとします。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">2. 個人情報の利用目的</h2>
          <p>当社は、個人情報を以下の目的で利用いたします。</p>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社のサービス、商品等（以下「当社サービス等」といいます。）の提供のため</li>
            <li>当社サービス等に関するご案内、お問い合せ等への対応のため</li>
            <li>当社サービス等のご案内のため</li>
            <li>当社サービス等に関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため</li>
            <li>当社サービス等に関する規約等の変更などを通知するため</li>
            <li>当社サービス等の改善、新サービス、商品等の開発等に役立てるため</li>
            <li>取得した閲覧履歴、行動履歴及び購買履歴等の情報を把握・分析し、当社サービスの改善・機能追加の実施並びに興味・嗜好に応じた新商品・サービス関する開発・広告を行うため</li>
            <li>雇用管理、社内手続のため（役職員の個人情報について）</li>
            <li>株主管理、会社法その他法令上の手続対応のため（株主、新株予約権者等の個人情報について）</li>
            <li>当社サービス等に関連して、個人を識別できない形式に加工した統計データを作成するため</li>
            <li>その他、上記利用目的に付随する目的のため</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">3. 個人情報利用目的の変更</h2>
          <p>当社は、個人情報の利用目的について、関連性を有すると合理的に認められる範囲内において変更することがあり、変更した場合には個人情報の主体である個人（以下「本人」といいます。）に通知又は公表します。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">4. 個人情報利用の制限</h2>
          <p>当社は、個人情報保護法その他の法令により許容される場合を除き、本人の同意を得ず利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。但し次の場合はこの限りではありません。</p>
          <ol className="list-decimal pl-5 space-y-1">
            <li>法令に基づく場合</li>
            <li>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
            <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
            <li>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
            <li>学術研究機関等に個人データを提供する場合であって、当該学術研究機関等が当該個人データを学術研究目的で取り扱う必要があるとき（当該個人データを取り扱う目的の一部が学術研究目的である場合を含み、個人の権利利益を不当に侵害するおそれがある場合を除きます。）</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">5. 個人情報の適正な取得</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。</li>
            <li>当社は、次の場合を除き、あらかじめ本人の同意を得ないで、要配慮個人情報（個人情報保護法第2条第3項に定義されるものを意味します。）を取得しません。
              <ol className="list-decimal pl-5 mt-2 space-y-1">
                <li>第4項第1号ないし第4号のいずれかに該当する場合</li>
                <li>学術研究機関等から要配慮個人情報を取得する場合であって、当該要配慮個人情報を学術研究目的で取得する必要があるとき（当該要配慮個人情報を取得する目的の一部が学術研究目的である場合を含み、個人の権利利益を不当に侵害するおそれがある場合を除きます。）（当社と当該学術研究機関等が共同して学術研究を行う場合に限ります。）。</li>
                <li>当該要配慮個人情報が、本人、国の機関、地方公共団体、個人情報保護法第76条第1項各号に掲げる者その他個人情報保護委員会規則で定める者により公開されている場合</li>
                <li>本人を目視し、又は撮影することにより、その外形上明らかな要配慮個人情報を取得する場合</li>
                <li>第7.1項但書によって第三者提供にあたらないものとされる態様にて要配慮個人情報の提供を受けるとき</li>
              </ol>
            </li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">6. 個人情報の安全管理</h2>
          <p>当社は、個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。また、当社は、個人情報の取扱いの全部又は一部を委託する場合は、委託先において個人情報の安全管理が図られるよう、必要かつ適切な監督を行います。当社の安全管理措置の概要は以下のとおりです。</p>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、個人情報保護法及びこれに関連する法令並びに適用されるガイドライン等を遵守するとともに、第15項において示した窓口にて、個人データの取扱いに関するご質問・相談及び苦情を受け付けることとしています。</li>
            <li>当社は、取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者・担当者及びその任務等を定めます。</li>
            <li>個人データの取扱いに関する責任者を設置するとともに、整備した取扱方法に従って個人データが取り扱われていることを責任者が確認します。また、当社は、法令等や内部規程等に違反している事実またはそのおそれを把握した場合の従業者から責任者に対する報告連絡体制を整備します。さらに、個人データの取扱状況について、責任者が定期的な点検を行います。</li>
            <li>個人データの取扱いに関する留意事項について、従業員に必要な研修を実施します。また、個人データについての秘密保持に関する事項を就業規則に記載します。</li>
            <li>個人データを取り扱うことのできる従業者及び本人以外が容易に個人データを閲覧できない措置を実施します。また、個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するため、個人データが記録された電子媒体又は個人データが記載された書類等を、施錠できるキャビネット・書庫等に保管します。さらに、個人データを取り扱う情報システムが機器のみで運用されている場合は、当該機器をセキュリティワイヤー等により固定します。上記のほか、個人データを取り扱う機器、電子媒体及び書類等の盗難又は紛失等を防止するために必要な措置を講じるとともに、事業所内の移動を含め、当該機器、電子媒体等を持ち運ぶ場合、容易に個人データが判明しないよう措置を実施します。</li>
            <li>個人データを取り扱うことのできる機器及び当該機器を取り扱う従業者を明確化し、個人データへの不要なアクセスを防止します。個人データを取り扱う機器を外部からの不正アクセス又は不正ソフトウェアから保護する仕組みを導入します。</li>
            <li>個人データを削除し、又は個人データが記録された機器及び電子媒体等を廃棄した場合、責任者が確認をします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">7. 第三者提供</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、第4項及び第7項5号のいずれかに該当する場合を除くほか、あらかじめ本人の同意を得ないで、個人情報を第三者に提供しません。但し、次に掲げる場合は上記に定める第三者への提供には該当しません。
              <ol className="list-decimal pl-5 mt-2 space-y-1">
                <li>当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託することに伴って個人情報を提供する場合</li>
                <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
                <li>個人情報保護法の定めに基づき共同利用する場合</li>
              </ol>
            </li>
            <li>第7.1項の定めにかかわらず、当社は、第4項各号までのいずれかに該当する場合を除くほか、外国（個人情報保護法第24条に基づき個人情報保護委員会規則で指定される国を除きます。）にある第三者（個人情報保護法第24条に基づき個人情報保護委員会規則で指定される基準に適合する体制を整備している者を除きます。）に個人情報を提供する場合には、あらかじめ外国にある第三者への提供を認める旨の本人の同意を得ることその他個人情報保護法に基づく措置を講じるものとします。</li>
            <li>当社は、個人情報を第三者に提供したときは、個人情報保護法第25条に従い、記録の作成及び保存を行います。</li>
            <li>当社は、第三者から個人情報の提供を受ける場合には、個人情報保護法第30条に従い、必要な確認を行い、当該確認にかかる記録の作成及び保存を行うものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">8. 個人関連情報</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、個人関連情報（個人情報保護法の定義によります。以下同様とします。）を第三者より取得し個人データとして利用する場合には、あらかじめ、当社が当該個人関連情報を個人データとして取得することにつき本人の同意をいただく等の対応を行うとともに、第2項の利用目的の範囲内で利用します。</li>
            <li>当社は個人関連情報を第三者に提供するに際し、当該第三者が個人関連情報を個人データとして利用することが想定される場合には、当該第三者が当該個人関連情報を個人データとして取得することにつきあらかじめ本人の同意を得ていること等を確認します。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">9. 個人情報の開示</h2>
          <p>当社は、本人から、個人情報が真実でないという理由によって、個人情報保護法の定めに基づきその内容の訂正、追加又は削除（以下「訂正等」といいます。）を求められた場合には、本人ご自身からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨を本人に通知します（訂正等を行わない旨の決定をしたときは、本人に対しその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が訂正等の義務を負わない場合は、この限りではありません。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">10. 個人情報の訂正等</h2>
          <p>当社は、本人から、個人情報が真実でないという理由によって、個人情報保護法の定めに基づきその内容の訂正、追加又は削除（以下「訂正等」といいます。）を求められた場合には、本人ご自身からのご請求であることを確認の上で、利用目的の達成に必要な範囲内において、遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正等を行い、その旨を本人に通知します（訂正等を行わない旨の決定をしたときは、本人に対しその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が訂正等の義務を負わない場合は、この限りではありません。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">11. 個人情報の利用停止等</h2>
          <p>当社は、本人から、本人の個人情報が、あらかじめ公表された利用目的の範囲を超えて取り扱われているという理由又は偽りその他不正の手段により取得されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止又は消去（以下「利用停止等」といいます。）を求められた場合、又は個人情報がご本人の同意なく第三者に提供されているという理由により、個人情報保護法の定めに基づきその提供の停止（以下「提供停止」といいます。）を求められた場合において、そのご請求に理由があることが判明した場合には、本人ご自身からのご請求であることを確認の上で、遅滞なく個人情報の利用停止等又は提供停止を行い、その旨を本人に通知します。但し、個人情報保護法その他の法令により、当社が利用停止等又は提供停止の義務を負わない場合は、この限りではありません。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">12. 匿名加工情報の取扱い</h2>
          <ol className="list-decimal pl-5 space-y-2">
            <li>当社は、匿名加工情報（個人情報保護法第2条第6項に定めるものを意味し、同法第16条第6項に定める匿名加工情報データベース等を構成するものに限ります。以下同じ。）を作成するときは、個人情報保護委員会規則で定める基準に従い、個人情報を加工するものとします。</li>
            <li>当社は、匿名加工情報を作成したときは、個人情報保護委員会規則で定める基準に従い、安全管理のための措置を講じます。</li>
            <li>当社は、匿名加工情報を作成したときは、個人情報保護委員会規則で定めるところにより、当該匿名加工情報に含まれる個人に関する情報の項目を公表します。</li>
            <li>当社は、匿名加工情報（当社が作成したもの及び第三者から提供を受けたものを含みます。以下別段の定めがない限り同様とします。）を第三者に提供するときは、個人情報保護委員会規則で定めるところにより、あらかじめ、 第三者に提供される匿名加工情報に含まれる個人に関する情報の項目及びその提供の方法について公表するとともに、当該第三者に対して、当該提供に係る情報が匿名加工情報である旨を明示します。</li>
            <li>当社は、匿名加工情報を取り扱うに当たっては、匿名加工情報の作成に用いられた個人情報に係る本人を識別するために、(1)匿名加工情報を他の情報と照合すること、及び(2)当該個人情報から削除された記述等若しくは個人識別符号若しくは個人情報保護法第43条第1項の規定により行われた加工の方法に関する情報を取得すること（(2)は第三者から提供を受けた当該匿名加工情報についてのみ）を行わないものとします。</li>
            <li>当社は、匿名加工情報の安全管理のために必要かつ適切な措置、匿名加工情報の作成その他の取扱いに関する苦情の処理その他の匿名加工情報の適正な取扱いを確保するために 必要な措置を自ら講じ、かつ、当該措置の内容を公表するよう努めるものとします。</li>
          </ol>
        </div>

        <div>
          <h2 className="text-lg font-semibold">13. Cookie（クッキー）その他の技術の利用</h2>
          <p>当社のサービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、当社による当社のサービスの利用状況等の把握に役立ち、サービス向上に資するものです。Cookieを無効化されたいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。但し、Cookieを無効化すると、当社のサービスの一部の機能をご利用いただけなくなる場合があります。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">14. 外部サービスの利用（Google Analytics）について</h2>
          <p>当社のサービスは、ユーザーの訪問状況を把握するためにGoogle社提供のアクセス解析サービス「Googleアナリティクス」および「Googleアナリティクスの広告向け機能」を利用する場合があります。</p>
          <p>利用を行う機能は以下のとおりです。</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Googleアナリティクスリマーケティング</li>
            <li>Googleディスプレイネットワークのインプレッションレポート</li>
            <li>Googleアナリティクスのユーザー属性とインタレストカテゴリに関するレポート</li>
          </ul>
          <p>GoogleアナリティクスはCookieを利用して利用者の情報を収集します。当社は、Google社からその分析結果を受け取り、お客様の本サイトの訪問状況を把握します。（詳細につきましてはGoogleアナリティクス利用規約をご覧ください。）</p>
          <p>Googleアナリティクスにより収集、記録、分析されたお客様の情報には、特定の個人を識別する情報は含まれません。また、それらの情報は、Google社により同社のプライバシーポリシーに基づいて管理されます。</p>
          <p>また、当社およびGoogle社を含む第三者配信事業者は、ファーストパーティCookie (GoogleアナリティクスのCookieなど) または他のファーストパーティIDとサードパーティCookieまたは他のサードパーティIDを組み合わせ、当社サービスを訪れるユーザーの属性や興味・関心の分析に利用しております。</p>
          <p>なお、ブラウザのアドオン設定でGoogleアナリティクスを無効にすることにより、当社のGoogleアナリティクス利用によるお客様の情報の収集を停止することも可能です。設定につきましては、Google社によるオプトアウトアドオンのダウンロードページをご利用ください。</p>
        </div>

        <div>
          <h2 className="text-lg font-semibold">15. お問い合わせ</h2>
          <p>開示等のお申出、ご意見、ご質問、苦情のお申出その他個人情報の取扱いに関するお問い合わせは、下記の窓口まで電話又はEmailにてお願い致します。</p>
          <address className="not-italic">
東京都港区一丁目4番5号<br />
株式会社ジーンクエスト<br />
E-mail: <a className="underline" href="mailto:info@pishatto.jp">info@pishatto.jp</a>
          </address>
        </div>

        <div>
          <h2 className="text-lg font-semibold">16. 継続的改善</h2>
          <p>当社は、個人情報の取扱いに関する運用状況を適宜見直し、継続的な改善に努めるものとし、必要に応じて、本プライバシーポリシーを変更することがあります。</p>
        </div>
      </section>
    </LegalLayout>
  );
};

export default PrivacyPolicy;


